import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { removeProduct, clearWishlist } from "../redux/wishSlice";
import ProductImage from "../components/ProductImage";
import { FiHeart, FiTrash2, FiArrowLeft, FiChevronLeft, FiEye } from 'react-icons/fi';
import { HiOutlineSparkles } from 'react-icons/hi';
import styles from "../styles/wishlist.module.css";
import { categoryLabel, categoryNames } from "../components/ProductCard";

const REMOVE_ANIM_MS = 340;

const WishList = () => {
  const wishlist = useSelector((state) => state.wishlist.wishlist);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [removingIds, setRemovingIds] = useState([]);
  const [clearing, setClearing] = useState(false);

  const remove = (product) => {
    setRemovingIds((ids) => [...ids, product.product_id]);
    setTimeout(() => {
      dispatch(removeProduct(product));
      setRemovingIds((ids) => ids.filter(id => id !== product.product_id));
    }, REMOVE_ANIM_MS);
  };

  const clearAll = () => {
    setClearing(true);
    setTimeout(() => {
      dispatch(clearWishlist());
      setClearing(false);
    }, REMOVE_ANIM_MS);
  };

  return (
    <div className={styles.page}>
      <nav className={styles.breadcrumb}>
        <Link to="/">الرئيسية</Link>
        <FiChevronLeft />
        <span>المفضلة</span>
      </nav>

      <header className={styles.header}>
        <h1 className={styles.title}>
          <span className={styles.titleIcon}><FiHeart /></span>
          قائمة المفضلة
        </h1>
        {wishlist.length > 0 && (
          <span className={styles.countChip}>{wishlist.length} لوحة</span>
        )}
        {wishlist.length > 1 && (
          <button className={styles.clearBtn} onClick={clearAll}>
            <FiTrash2 /> مسح الكل
          </button>
        )}
      </header>

      {wishlist.length === 0 ? (
        <div className={styles.empty}>
          <span className={styles.emptyIcon}><FiHeart /></span>
          <h2 className={styles.emptyTitle}>قائمة المفضلة فارغة</h2>
          <p className={styles.emptySub}>
            تصفح معرض اللوحات واضغط على القلب لحفظ لوحاتك المفضلة والمقارنة بينها بسهولة
          </p>
          <button className={styles.emptyCta} onClick={() => navigate("/products")}>
            <HiOutlineSparkles /> تصفح اللوحات
          </button>
        </div>
      ) : (
        <>
          <div className={styles.grid}>
            {wishlist.map((item, i) => (
              <article
                key={item.product.product_id}
                className={`${styles.card} ${
                  clearing || removingIds.includes(item.product.product_id) ? styles.removing : ''
                }`}
                style={{ '--i': i }}
              >
                <div
                  className={styles.media}
                  onClick={() => navigate(`/product/${item.product.product_id}`)}
                >
                  <ProductImage
                    url={item.product.image_url}
                    alt={item.product.name}
                    loading="lazy"
                    className={styles.image}
                  />
                  <div className={styles.mediaOverlay}>
                    <span className={styles.quickView}><FiEye /> عرض اللوحة</span>
                  </div>
                  <span className={styles.heartBadge}><FiHeart /></span>
                  <button
                    aria-label="إزالة من المفضلة"
                    className={styles.removeBtn}
                    onClick={(e) => {
                      e.stopPropagation();
                      remove(item.product);
                    }}
                  >
                    <FiTrash2 />
                  </button>
                </div>

                <div className={styles.body}>
                  {categoryLabel(item.product) && (
                    <span className={styles.categoryTag} title={categoryNames(item.product).join('، ')}>
                      {categoryLabel(item.product)}
                    </span>
                  )}
                  <h3
                    className={styles.name}
                    onClick={() => navigate(`/product/${item.product.product_id}`)}
                  >
                    {item.product.name}
                  </h3>
                  <div className={styles.priceRow}>
                    <p className={styles.price}>
                      {item.lowestPrice != null && (
                        <>
                          <span className={styles.priceLabel}>يبدأ من</span>
                          <span className={styles.priceValue}>{item.lowestPrice} ₪</span>
                        </>
                      )}
                    </p>
                    <button
                      className={styles.viewBtn}
                      onClick={() => navigate(`/product/${item.product.product_id}`)}
                    >
                      <FiArrowLeft />
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </div>

          <div className={styles.moreBanner}>
            <div className={styles.moreText}>
              <h3>لم تجد لوحتك بعد؟</h3>
              <p>اكتشف المزيد من اللوحات الفنية المميزة في معرضنا الكامل</p>
            </div>
            <button className={styles.moreCta} onClick={() => navigate("/products")}>
              اكتشف المزيد <FiArrowLeft />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default WishList;
